import { useTranslation } from "react-i18next";

import { INoPresenceConditions } from "interfaces/rules.interface";

import { InfoField } from "./InfoField";

type LogPresetNoPresenceProps = {
  preset: INoPresenceConditions;
  state?: string;
};

export function LogPresetNoPresence({
  preset,
  state,
}: LogPresetNoPresenceProps) {
  const { t } = useTranslation();

  return (
    <>
      <InfoField
        label={t("minimum_time_presence_is")}
        value={(preset.initial_presence_time_epochs_gte ?? 0) / 2}
        unit={t("mins")}
      />
      <InfoField
        label={
          state === "ok"
            ? t("time_with_presence_is")
            : t("time_with_no_presence_is")
        }
        value={(preset.ok_to_alert?.no_presence_time_epochs_gte ?? 0) / 2}
        unit={t("mins")}
      />
      <InfoField
        label={t("time_presence_is_greater_than")}
        value={(preset.alert_to_ok?.presence_time_epochs_gte ?? 0) / 2}
        unit={t("mins")}
      />
    </>
  );
}
